import { Component, Input} from '@angular/core';
import { UserManagementService } from '../../../user-management/user-management.services';

@Component({
    selector: 'display-login-user',
    templateUrl: './display-login-user.html',
    styleUrls: ['./display-login-user.scss']
})
export class DisplayLoginUser {

    userProfile:any = {
        picture:"assets/img/theme/no-photo.png",
        firstName:"",
        login:""
    }

    constructor(private _usersService: UserManagementService) {
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this._usersService.GetUser(currentUser.id).subscribe(response => {
                if (response.data.photo) {

                    this.userProfile.picture = "data:image/jpeg;base64," + response.data.photo;
                }

                this.userProfile.firstName = response.data.firstname;
                this.userProfile.login = response.data.username;
        });
    }
    
    ngOnDestroy(): void {
     
    }
}
